import { TagSelect } from "shared";
import { IBusinessGroup, templatesService } from "entities/template";
import React, { useEffect, useMemo, useState } from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";

interface IBusinessGroupsProps {
    limitToBusinessGroups?: number[];
    onChange: (value: number[]) => void

}

export const BusinessGroups: React.FC<IBusinessGroupsProps> = React.memo(({
                                                                              limitToBusinessGroups,
                                                                              onChange
                                                                          }) => {
    const t = useComponentsTranslations();
    const [loading, setLoading] = useState<boolean>(false);
    const [businessGroups, setBusinessGroups] = useState<IBusinessGroup[]>([]);

    useEffect(() => {
        setLoading(true);
        templatesService.loadBusinessGroups().then(res => {
            setLoading(false);
            setBusinessGroups(res);
        })
    }, [])

    const constructOptions = useMemo(() => {
        return businessGroups.map((bg) => {
            return {
                value: bg.id.toString(),
                label: bg.name
            }
        })
    }, [businessGroups])

    return <TagSelect value={limitToBusinessGroups ? limitToBusinessGroups.map(id => id.toString()) : []}
                      options={constructOptions}
                      loading={loading}
                      placeholder={t("businessGroupsField")}
                      onChange={(value) => onChange(value.map(idStr => parseInt(idStr)))}/>
});
